<template>
  <PrintPageLandscape :page-number="pageNumber" :page-count="pageCount">
    <PresentationCover
      class="presentation-cover--reference"
      :background-image="referenceBackgroundImage"
    >
      <template #corner><i>e way</i></template>

      <div class="presentation-cover__reference-panel">
        <p class="presentation-cover__eyebrow">Projekt</p>

        <h1 class="presentation-cover__reference-title">
          {{ this.project.employerProjectNumber }}
        </h1>

        <div class="presentation-cover__accent" aria-hidden="true"></div>

        <p class="presentation-cover__reference-text">
          PV-Dachanlage mit Gestattungsvertrag · {{ overallInstallationPower }} kWp
        </p>
      </div>
    </PresentationCover>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationCover from '@/views/MasterPresentation/PresentationCover';
import { formatNumber, NUMBER_FORMAT } from '@/helpers/numberFormat';

/** Matches {@link PROJECT_ATTACHMENT_TYPES.SHORT_TEASER_PROPERTY_IMAGE} on the server */
const SHORT_TEASER_PROPERTY_IMAGE_ATTACHMENT_TYPE = 'SHORT_TEASER_PROPERTY_IMAGE';

export default {
  name: 'MasterPresentationPrintPage32',

  components: {
    PrintPageLandscape,
    PresentationCover,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  computed: {
    overallInstallationPower() {
      return formatNumber(
        this.project?.solarPlant?.solarPlantOverallPower,
        NUMBER_FORMAT.DECIMAL_TRIPLE
      );
    },

    referenceBackgroundImage() {
      const attachments = this.project?.attachments;
      if (!Array.isArray(attachments) || attachments.length === 0) {
        return '';
      }

      const propertyImages = attachments.filter(
        (attachment) => attachment.attachmentType === SHORT_TEASER_PROPERTY_IMAGE_ATTACHMENT_TYPE
      );
      if (propertyImages.length === 0) {
        return '';
      }

      return this.attachmentSrcPreferFullResolution(propertyImages[0]);
    },
  },

  methods: {
    sanitizeAttachmentPath(path) {
      if (!path || typeof path !== 'string') {
        return '';
      }
      if (path.indexOf('https://') !== 0) {
        return 'https://' + path;
      }
      return path;
    },

    /**
     * Use full-resolution file URL for print. Thumbnails are small previews intended for lists.
     */
    attachmentSrcPreferFullResolution(attachment) {
      if (!attachment) {
        return '';
      }
      if (attachment.path) {
        return this.sanitizeAttachmentPath(attachment.path);
      }
      if (attachment.thumbnail) {
        return this.sanitizeAttachmentPath(attachment.thumbnail);
      }
      return '';
    },
  },
};
</script>
